import { FC } from 'react';
import { CreateAgencyCard } from 'features/agency';

export const CreateAgencyPage: FC = () => {
  return <CreateAgencyCard />;
};
